import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatMenuModule } from '@angular/material/menu';

import { PhonebookTypes } from '../../../../../core/api/models/phonebook-types';
import { TranslationModule } from '../../../../../i18n/translation.module';
import { PhonebookCustomDto } from '../../shared/phonebook-custom.model';
import { GetEnumValuesDto } from './../../../../../core/api/models/get-enum-values-dto';
import { MenuBtnComponent } from 'src/app/shared/global/menu-btn/menu-btn.component';

@Component({
    selector: 'phonebook-row-menu',
    imports: [CommonModule, TranslationModule, MatMenuModule, MenuBtnComponent],
    templateUrl: `./phonebook-row-menu.component.html`
})
export class PhonebookRowMenuComponent {
  @Input() item: PhonebookCustomDto;
  @Input() PhonebookTypesEnumValues: GetEnumValuesDto[] = [];
  @Output() operation = new EventEmitter<PhonebookRowMenuOperation>();
  get PhonebookTypes() {
    return PhonebookTypes;
  }
  matMenuItems: PhonebookRowMatMenuItem[] = [
    {
      operation: PhonebookRowMenuOperation.edit,
      iconClass: 'mdi-pencil-outline mdi-24px text-navyBlue',
      color: 'text-navyBlue',
      label: 'edit',
      condition: () => {
        return this.item?.phonebookTypes != PhonebookTypes.ParentPublic;
      },
    },
    {
      operation: PhonebookRowMenuOperation.customFields,
      iconClass: 'mdi-table-plus mdi-24px text-info',
      color: 'text-info',
      label: 'customFields',
      condition: () => {
        return true;
      },
    },
    {
      operation: PhonebookRowMenuOperation.addSingle,
      iconClass: 'mdi-plus-circle-outline mdi-24px text-primary',
      color: 'text-primary',
      label: 'addSingle',
      condition: () => {
        return true;
      },
    },
    {
      operation: PhonebookRowMenuOperation.addListNumber,
      iconClass: 'mdi-text-box-plus-outline mdi-24px text-primary',
      color: 'text-primary',
      label: 'addListNumber',
      condition: () => {
        return true;
      },
    },
    {
      operation: PhonebookRowMenuOperation.addFromFile,
      iconClass: 'mdi-file-account-outline mdi-24px text-primary',
      color: 'text-primary',
      label: 'addFromFile',
      condition: () => {
        return true;
      },
    },
    {
      operation: PhonebookRowMenuOperation.downloadAll,
      iconClass: 'mdi-download-outline mdi-24px text-success',
      color: 'text-success',
      label: 'downloadAll',
      condition: () => {
        return this.item?.phonebookTypes != PhonebookTypes.ParentPublic;
      },
    },
    // {
    //   operation: PhonebookRowMenuOperation.delete,
    //   iconClass: 'mdi-trash-can-outline mdi-24px text-danger',
    //   color: 'text-danger',
    //   label: 'delete',
    //   condition: () => {
    //     return true;
    //   },
    // },
    {
      operation: PhonebookRowMenuOperation.deleteAll,
      iconClass: 'mdi-trash-can-outline mdi-24px text-danger',
      color: 'text-danger',
      label: 'deleteAllContact',
      condition: () => {
        return true;
      },
    },
  ];

  onOperation(operation: PhonebookRowMenuOperation) {
    this.operation.emit(operation);

  }
}

export interface PhonebookRowMatMenuItem {
  operation?: PhonebookRowMenuOperation;
  label?: string;
  iconClass?: string;
  color?: string;
  condition?: Function;
}

export enum PhonebookRowMenuOperation {
  edit = 'edit',
  customFields = 'customFields',
  addSingle = 'addSingle',
  addListNumber = 'addListNumber',
  addFromFile = 'addFromFile',
  downloadAll = 'downloadAll',
  delete = 'delete',
  deleteAll = 'deleteAll',
}
